import { HttpClient } from '@angular/common/http';
import { Observable,  BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../../environments/environment';
import { HttpUtilsService } from '../../../../../../core/_base/crud/utils/http-utils.service';
import { QueryParamsModel, QueryResultsModel } from '../../../../../../core/_base/crud';
import { DeNghiNhapKho, DeNghiNhapKhoChiTiet } from '../phieu-thong-tin-hang-ve-ver2-model/phieu-thong-tin-hang-ve-ver2.model';
const API_ROOT_URL = environment.ApiRoot + '/kho';

@Injectable()
export class ThongTinHangVeService {
	lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
	lastFilterDSExcel$: BehaviorSubject<any[]> = new BehaviorSubject([]);
	lastFilterInfoExcel$: BehaviorSubject<any> = new BehaviorSubject(undefined);
	lastFileUpload$: BehaviorSubject<{}> = new BehaviorSubject({});
	data_import:  BehaviorSubject<any[]> = new BehaviorSubject([]);
	ReadOnlyControl: boolean;
	constructor(private http: HttpClient,
	private httpUtils: HttpUtilsService) { }

	getData(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/TTHV_List', { 
			headers: httpHeaders,
			params: httpParams
		});
	}
	getDataDetail(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/TTHV_List_Detail', { 
			headers: httpHeaders,
			params: httpParams
		});
	}

	addDetail(item:DeNghiNhapKhoChiTiet): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiNhapKhoChiTiet>(API_ROOT_URL+'/TTHV_Insert_Detail', item, { headers: httpHeaders });
	}
	addThongTinHangVe(item: DeNghiNhapKho): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiNhapKho>(API_ROOT_URL+'/TTHV_Insert', item, { headers: httpHeaders });
	}
	getThongTinHangVeDetail(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiNhapKho>(API_ROOT_URL+'/TTHV_Get_Detail', item, { headers: httpHeaders });
	}
	getSoPhieuTiepTheo(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<DeNghiNhapKho>(API_ROOT_URL+'/TTHV_Get_NextID', { headers: httpHeaders });
	}
	getThongTinHangVeHistory(itemId): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/TTHV_Get_History?IdDn=${itemId}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	updateThongTinHangVeWithDetail(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiNhapKho>(API_ROOT_URL+'/TTHV_Update_With_Detail', item, { headers: httpHeaders });
	}
	updateOnlyThongTinHangVe(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiNhapKho>(API_ROOT_URL+'/TTHV_Duyet', item, { headers: httpHeaders });
	}
	checkCancelThongTinHangVe(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/TTHV_Check_Cancel?IdDn=${itemId}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	huyThongTinHangVe(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiNhapKho>(API_ROOT_URL+'/TTHV_Huy', item, { headers: httpHeaders });
	}
	XacNhanKiemTra(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiNhapKho>(API_ROOT_URL+'/TTHV_Confirm', item, { headers: httpHeaders });
	}
	KiemTraTungHang(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiNhapKhoChiTiet>(API_ROOT_URL+'/TTHV_XacNhanHang', item, { headers: httpHeaders });
	}
	TPXacNhanTungHang(item): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiNhapKhoChiTiet>(API_ROOT_URL+'/TTHV_TP_Confirm', item, { headers: httpHeaders });
	}
	GDXacNhanTungHang(item): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiNhapKhoChiTiet>(API_ROOT_URL+'/TTHV_GĐ_Confirm', item, { headers: httpHeaders });
	}
	deleteThongTinHangVe(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/TTHV_Delete?IdDn=${itemId}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	listHangHoa() : Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url =  environment.ApiRoot + '/danhmuc' + '/Hang_Hoa_List' ;
		return this.http.get<any>(url , { headers: httpHeaders });
	}
	listListNCC() : Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url =  environment.ApiRoot + '/danhmuc' + '/DM_NCC_List' ;
		return this.http.post<any>(url, null , { headers: httpHeaders });
	}
	listNV() : Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url =  environment.ApiRoot + '/danhmuc' + '/DM_NhanVien_List' ;
		return this.http.get<any>(url , { headers: httpHeaders });
	}
	listKho() : Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url =  environment.ApiRoot + '/danhmuc' + '/Kho_List' ;
		return this.http.get<any>(url , { headers: httpHeaders });
	}
	listBoPhanKiemTra() : Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url =  environment.ApiRoot + '/danhmuc' + '/DM_PhongBan_List' ;
		return this.http.post<any>(url, null , { headers: httpHeaders });
	}

	listLO() : Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url =  environment.ApiRoot + '/danhmuc' + '/LotHH_List' ;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
}
